import { render, staticRenderFns } from "./LinkPopin.vue?vue&type=template&id=7d1d464c&scoped=true&lang=pug&"
import script from "./LinkPopin.vue?vue&type=script&lang=js&"
export * from "./LinkPopin.vue?vue&type=script&lang=js&"
import style0 from "./LinkPopin.vue?vue&type=style&index=0&id=7d1d464c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1d464c",
  null
  
)

export default component.exports